import {useCallback,useEffect,useRef,useState} from 'react';
import {Hub} from 'aws-amplify/utils';
import {questRequest,questsConfigured} from './questsApi';
export default function useQuestWorkspace(admin){
  const [data,setData]=useState(null),[busy,setBusy]=useState(false),[error,setError]=useState(''),[blocked,setBlocked]=useState(false);
  const generation=useRef(0),controller=useRef(null),lock=useRef(false),owner=useRef(null),lastQuery=useRef({});
  const execute=useCallback(async(change,query,replace,expectedOwner)=>{
    if(lock.current)return null;
    lock.current=true;const version=generation.current,abort=new AbortController();controller.current=abort;
    setBusy(true);setError('');
    try{
      const expected=expectedOwner||owner.current;
      if((change||!replace)&&(!expected||expected!==owner.current))throw Object.assign(Error('Your account changed. Reload quests.'),{code:'ACCOUNT_CHANGED'});
      const result=await questRequest(admin,change,query,abort.signal,change||!replace?expected:null);
      if(version!==generation.current||abort.signal.aborted)return null;
      owner.current=result._owner;if(replace){setData(result);lastQuery.current=query;setBlocked(false);}return result;
    }catch(failure){
      if(version===generation.current&&!abort.signal.aborted){setError(failure.message);if(change&&(!failure.status||failure.status>=500||failure.status===409))setBlocked(true);if(failure.code==='ACCOUNT_CHANGED'){setData(null);owner.current=null;setBlocked(true);}}
      return null;
    }finally{if(version===generation.current){lock.current=false;setBusy(false);}}
  },[admin]);
  const load=useCallback((query={})=>execute(null,query,true),[execute]);
  const read=useCallback(query=>execute(null,query,false),[execute]);
  const change=useCallback(async(body,{reload=true,expectedOwner}={})=>{
    const result=await execute(body,{},false,expectedOwner);
    if(result&&reload&&!(await load(lastQuery.current)))setBlocked(true);
    return result;
  },[execute,load]);
  const invalidate=useCallback(reset=>{
    generation.current++;controller.current?.abort();lock.current=false;owner.current=null;
    if(reset){setData(null);setBusy(false);setBlocked(true);setError('Your account changed. Reload quests.');}
  },[]);
  useEffect(()=>{
    if(questsConfigured())load();
    const off=Hub.listen('auth',({payload})=>{if(['signedIn','signedOut','tokenRefresh_failure'].includes(payload.event))invalidate(true);});
    return()=>{invalidate(false);off();};
  },[load,invalidate]);
  return {data,busy,error,blocked,load,read,change,configured:questsConfigured()};
}
